import React, { useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import RegularButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import { Search, Visibility } from '@material-ui/icons';
import { Toasty, useToasty } from 'hooks/Toasty';
import GridItem from 'components/Grid/GridItem';
import { useNavigate } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import { wsFindBy } from 'services/WService';
import moment from 'moment';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

// Modales
import ModalFull from 'components/Tvendo/Common/ModalFull';
import OrdmOrderDetailShared from 'components/Tvendo/Sale/Operations/OrderWebMovil/OrdmOrderDetailShared';
import SaleOrderDetail from 'components/Tvendo/Sale/Operations/SaleOrder/SaleOrderDetail';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 75 },
  { Header: 'Estado', accessor: 'state', width: 150 },
  { Header: 'Fecha creación', accessor: 'created_at', width: 150 },
  { Header: 'Monto', accessor: 'total_amount', width: 150 },
  { Header: 'Cod.Socio', accessor: 'CardCode', width: 150 },
  { Header: 'Socio', accessor: 'CardName' },
  { Header: 'Vendedor', accessor: 'SlpName', width: 300 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function OrdersByPromotion() {
  const [notify, showNotify] = useToasty();
  const navigate = useNavigate();
  const [promotionId, setPromotionId] = useState('');
  const [ruleId, setRuleId] = useState('');
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

  const [orders, setOrders] = useState([]);

  const [open, setOpen] = useState(false);
  const [idOrder, setIdOrder] = useState(null);

  const [saleOpen, setSaleOpen] = useState(false);
  const [idSaleOrder, setIdSaleOrder] = useState(null);

  const [dataLoading, setDataLoading] = useState(false);
  async function listOrders() {
    let data = {
      start_date: startDate,
      end_date: endDate,
    };
    setDataLoading(true);
    if (promotionId !== '') {
      data.prom_promotion_id = promotionId;
    }
    if (ruleId !== '') {
      data.prom_rule_id = ruleId;
    }
    if (promotionId === '' && ruleId === '') {
      window.alert('Seleccione una promoción o regla');
      return;
    }
    let res = await wsFindBy('prom/promotion/orders', data);
    setDataLoading(false);
    if (res.success) {
      setOrders(res.data);
    }
  }

  return (
    <CardContainer /*title="Pedidos por promoción"*/ title={(<>Pedidos por promoción {dataLoading && <LoadingSpinner />}</>)}>
      <Toasty action={notify} />
      {/* Modal OrdmOrders */}
      {open && (
        <ModalFull title="Detalles ordm" open={open} setOpen={setOpen}>
          <OrdmOrderDetailShared idOrder={idOrder} />
        </ModalFull>
      )}

      {/* Modal SaleOrders */}
      {saleOpen && (
        <ModalFull title="Detalles sale" open={saleOpen} setOpen={setSaleOpen}>
          <SaleOrderDetail
            idOrder={idSaleOrder}
            showNotify={showNotify}
            reload={() => {
              setSaleOpen(false);
            }}
          />
        </ModalFull>
      )}

      {/* Filtros */}
      <GridContainer>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <TextField
            fullWidth
            label="Id Promoción"
            type="number"
            value={promotionId}
            onChange={(e) => setPromotionId(e.target.value)}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <TextField
            fullWidth
            label="Id Regla"
            type="number"
            value={ruleId}
            onChange={(e) => setRuleId(e.target.value)}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <TextField
            fullWidth
            label="Desde"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <TextField
            fullWidth
            label="Hasta"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </GridItem>
        <GridItem xs={2}>
          <RegularButton justIcon round color="success" onClick={listOrders}>
            <Search />
          </RegularButton>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <ReactTable
            columns={columns}
            formatDate="DD-MM-YYYY HH:mm"
            data={orders.map((order, index) => {
              let state = '';
              if (order.sale_order_id !== null) {
                switch (order.state_migrate) {
                  case 'X':
                    state = 'Pendiente de programar';
                    break;
                  case 'P':
                    state = 'Programado';
                    break;
                  case 'G':
                    state = 'Facturado SAP';
                    break;
                  case 'S':
                    state = 'Sin stock';
                    break;
                  case 'R':
                    state = 'Reparto';
                    break;
                  case 'F':
                    state = 'Facturado';
                    break;
                  case 'D':
                    state = 'Borrador';
                    break;
                  case 'A':
                    state = 'Anulado';
                    break;
                }
              } else {
                switch (order.state) {
                  case 'N':
                    state = 'Normal';
                    break;
                  case 'X':
                    state = 'Por aprobar';
                    break;
                  case 'S':
                    state = 'Sin stock';
                    break;
                  case 'A':
                    state = 'Anulado';
                    break;
                  case 'E':
                    state = 'Editado';
                    break;
                  case 'P':
                    state = 'Procesado';
                    break;
                  case 'R':
                    state = 'Retenido';
                    break;
                }
              }
              return {
                num: (
                  <>
                    {index + 1}
                    <RegularButton
                      justIcon
                      round
                      simple
                      size="sm"
                      color="primary"
                      onClick={() => {
                        if (order.sale_order_id === null) {
                          setOpen(true);
                          setIdOrder(order.id);
                        } else {
                          setSaleOpen(true);
                          setIdSaleOrder(order.sale_order_id);
                        }
                      }}
                    >
                      <Visibility />
                    </RegularButton>
                  </>
                ),
                state,
                created_at: order.created_at,
                total_amount: order.total_amount,
                CardCode: order.CardCode,
                CardName: order.CardName,
                SlpName: `${order.SlpCode}-${order.SlpName}`,
              };
            })}
          />
        </GridItem>
      </GridContainer>
    </CardContainer>
  );
}

export default OrdersByPromotion;
